import classNames from 'classnames'
import { t } from 'i18next'
import { ReactNode } from 'react'

export interface IButton {
    color?: string
    className?: string
    size?: string
    textColor?: string
    textSize?: string
    text: string
    handleClick: (e: React.MouseEvent<HTMLButtonElement>) => void
    prefix?: ReactNode
    postfix?: ReactNode
    disabled?: boolean
}

const Button: React.FC<IButton> = ({
    className,
    color,
    textColor,
    textSize,
    text,
    handleClick,
    prefix,
    postfix,
    disabled,
}) => {
    return (
        <div className={classNames()}>
            <button
                type="button"
                onClick={handleClick}
                className={classNames(
                    className,
                    textColor ? textColor : 'text-white',
                )}
                disabled={disabled}
            >
                <div className={classNames("flex flex-row items-center justify-center ",
                    textSize ? textSize : 'text-lg'
                )}>
                    {prefix}
                    {t(text)}
                    {postfix}
                </div>
            </button>
        </div>
    )
}

export default Button
